import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom';
import { Dropdown, ButtonGroup, Button } from 'react-bootstrap';

import { Http } from '../../../../support';

class PrefacturasItemActions extends PureComponent {
  state = {
    busy: false,
  }

  handleOnDownloadActionClick = async (download) => {
    this.setState({
      busy: true
    });

    const { data } = this.props;

    const params = {
      download: download
    }

    try {
      const response = await Http.get(`${window.BONJOUR_URL}/api/prefacturas/${data.id}`, { params, responseType: 'blob' });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el PDF'
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  render() {
    const { data } = this.props;

    return (
      <>
        { data.status !== 1 && (
          <Dropdown as={ ButtonGroup } alignRight={ true }>
            <Link to={{
                pathname: '/app/comprobantes/timbrado',
                search: `t=${data.tipo}&p=${data.id}`
              }}>
              <Button variant="primary">
                Crear factura
              </Button>
            </Link>

            <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic" />

            <Dropdown.Menu>
              <Dropdown.Item as="div" onClick={ this.handleOnDownloadActionClick.bind(this, 1) }>Descargar PDF</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}

        { data.status === 1 && (
          <Button as={ Link }
            variant="secondary"
            to={{
              pathname: `/app/comprobantes/${data.uuid}/info`,
            }}
          >
            Ver comprobante
          </Button>
        )}
      </>
    )
  }
}

export default PrefacturasItemActions;